/**
 * Shared inline styles for the balanced editor.
 *
 * @module balancedStyles
 */

/**
 * Compresses the vertical padding of a SmartSelect (MUI Autocomplete) so its
 * height resembles the compact balanced node rows. Apply by wrapping the
 * SmartSelect in a `Box`/element with this `sx`; scoped to the balanced editor
 * so the generic SmartSelect stays unchanged elsewhere.
 *
 * @type {object}
 */
export const COMPACT_SELECT_SX = {
  '& .MuiAutocomplete-inputRoot': { paddingTop: 0, paddingBottom: 0 },
  '& .MuiAutocomplete-input': { paddingTop: '1.5px', paddingBottom: '1.5px' }
}

/**
 * Constrains a SmartSearch (styled MUI TextField) to a compact ~29px height so
 * the balanced tree/column search fields line up with the node rows. Pass via
 * the SmartSearch `sx` prop; scoped to the balanced editor.
 *
 * @type {object}
 */
export const COMPACT_SEARCH_SX = {
  '& .MuiOutlinedInput-root': { height: '29px', boxSizing: 'border-box' },
  '& .MuiOutlinedInput-input': { paddingTop: 0, paddingBottom: 0 }
}

// Search-match highlight (tree and columns): an amber tint kept visually distinct
// from the HU-07 `hasChanges` highlight so the two can coexist without ambiguity (R5).
export const SEARCH_MATCH_BACKGROUND = 'rgba(255, 213, 79, 0.22)'
export const SEARCH_MATCH_OUTLINE = '2px solid rgba(255, 213, 79, 0.9)'

// Multi-selection highlight (HU-04/09): a dashed cyan marker for JOBs picked with
// Ctrl/Cmd+click for a group drag; distinct from the search and info-selected styles.
export const MULTI_SELECT_BACKGROUND = 'rgba(120, 190, 255, 0.18)'
export const MULTI_SELECT_OUTLINE = '2px dashed rgba(120, 190, 255, 0.9)'

// hasChanges highlight (HU-07): a purple left accent bar marking JOBs whose data
// changed between versions. Uses the border-left channel so it coexists with the
// search highlight (background + outline) without ambiguity (R5).
export const HAS_CHANGES_BORDER = '3px solid rgba(186, 104, 200, 0.95)'
